import API from './api';
import store from '@/stores/index';

export default {
  async post (url, params = {}, config) {
    try {
      if (store.state.commonStore.isCallingApi) return;
      store.commit('commonStore/SET_IS_CALLING_API', true);
      let result = await API.post(url, params, config);
      store.commit('commonStore/SET_IS_CALLING_API', false);

      return result;
    } catch (e) {
      store.commit('commonStore/SET_IS_CALLING_API', false);
      return e;
    }
  },
  async get (url, params = {}) {
    try {
      return await API.get(url, params);
    } catch (e) {
      return e;
    }
  },
  async put (url, params = {}, config, headers) {
    try {
      if (store.state.commonStore.isCallingApi) return;
      store.commit('commonStore/SET_IS_CALLING_API', true);
      let result = await API.put(url, params, config, headers);
      store.commit('commonStore/SET_IS_CALLING_API', false);

      return result;
    } catch (e) {
      store.commit('commonStore/SET_IS_CALLING_API', false);
      return e;
    }
  },
  async getWithAuthentication (url, params = {}) {
    try {
      return await API.get(url, params);
    } catch (e) {
      return e;
    }
  },
  async postWithAuthentication (url, params = {}, config) {
    try {
      if (store.state.commonStore.isCallingApi) return;
      store.commit('commonStore/SET_IS_CALLING_API', true);
      let result = await API.post(url, params, {}, config);
      store.commit('commonStore/SET_IS_CALLING_API', false);

      return result;
    } catch (e) {
      store.commit('commonStore/SET_IS_CALLING_API', false);
      return e;
    }
  },
  async postWithoutIsCallingFlag (url, params = {}) {
    try {
      let result = await API.post(url, params);

      return result;
    } catch (e) {
      return e;
    }
  },
  showAjaxLoading: () => {
    API.showAjaxLoading()
  },
  hideAjaxLoading: () => {
    API.hideAjaxLoading()
  }
};



// WEBPACK FOOTER //
// ./src/services/apiService.js